import https from "@/utils/api";
// 施工升降梯
export const getDeviceElevator = () => {

  return https.get('screen/device/elevator').then(res=>{
    return res
  })
}
//塔式起重机
export const getDeviceCrane= () => {

  return https.get('screen/device/crane').then(res=>{
    return res
  })
}

export const getmapTotalInfo = (id) => {
  return https.get('/towerCluster/mapTotalInfo').then(res=>{
    return res
  })
}
//工程车辆
export const getDeviceCar= () => {

  return https.get('screen/device/car').then(res=>{
    return res
  })
}

export const getAlarmTrend = (id) => {
  const url = id ? `/towercraneRunningData/alarmTrend?equipmentNumber=${id}` : '/towercraneRunningData/alarmTrend';
  return https.get(url, '')
      .then(res => res.data);
}

export const getTowerEquipmentInfo  = (id) => {
  return https.get('/towercrane/towerEquipmentInfo?equipmentNumber=',id).then(res=>res.data)
}

export const getTowerInfo  = (id) => {
  return https.get('/towercraneRealTimeData/info?equipmentNumber=',id).then(res=>res.data)
}


export const getworkRecord  = (id) => {
  return https.get('/towercraneRunningData/workRecord?searchFlag=1&equipmentNumber=',id).then(res=>res.data)
}

export const getTowerHeaderTotal = () => {
  return https.get('/towercrane/towerHeaderTotal', '').then(res => res.data);
}
